import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("asow_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("asow_token");
  }
};

const saved = localStorage.getItem("asow_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
